import { render } from "./games.html?vue&type=template&id=1a6c1b2e&external"
import script from "./games.js?vue&type=script&lang=js&external"
export * from "./games.js?vue&type=script&lang=js&external"

import "./games.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__